import { HTTPv2, Service } from '../config'

class InspectionBreakdownService extends Service {
  async getVehiclePhotos(id: any) {
    const httpResponse = await this.httpClient.get(
      `/vistoriafoto?vistoriaId=${id ?? ''}`
    )
    return httpResponse
  }

  async setVehiclePhotoRefused(params: any) {
    const httpResponse = await this.httpClient.post(
      `/vistoriafoto/reprovar`,
      params
    )
    return httpResponse
  }

  async setVehiclePhotoRefusedAll(id: any) {
    const httpResponse = await this.httpClient.post(
      `/vistoriafoto/reprovar-tudo?vistoriaId=${id ?? ''}`
    )
    return httpResponse
  }

  async getBreakdownPhotos(id: any) {
    const httpResponse = await this.httpClient.get(
      `/vistoriaavaria/obteravarias?vistoriaId=${id ?? ''}`
    )
    return httpResponse
  }

  async setBreakdownRefused(params: any) {
    const httpResponse = await this.httpClient.post(
      `/vistoriaavaria/reprovar`,
      params
    )
    return httpResponse
  }

  async multipleBreakdownRefused(params: any) {
    const httpResponse = await this.httpClient.post(
      `/vistoriaavaria/reprovarLote`,
      params
    )
    return httpResponse
  }

  async setBreakdownRefusedAll(params: any) {
    const httpResponse = await this.httpClient.post(
      '/vistoriaavaria/reprovartodos',
      params
    )
    return httpResponse
  }

  async postBreakdownInspection(params: any) {
    const httpResponse = await this.httpClient.post('/vistoriaavaria', params)
    return httpResponse
  }

  async download(params: any) {
    const httpResponse = await HTTPv2.post(`/vistoriafoto/zip`, params)
    return httpResponse
  }

  async finished(params: any) {
    const httpResponse = await this.httpClient.post(
      `/vistoria/finalizarAvaliacao`,
      params
    )
    return httpResponse
  }

  async getVersion(id: any) {
    const httpResponse = await this.httpClient.get(
      `/vistoria/obterversoes?vistoriaId=${id ?? ''}`
    )
    return httpResponse
  }
}

export const inspectionBreakdownService = new InspectionBreakdownService()
